import React from "react";
import { useSelector } from "react-redux";
import { getElementById } from "../utils/styleUtils";

export const CustomDivider = ({ instanceId }) => {
  const formBuilder = useSelector((state) => state.customFormBuilder);
  const element = getElementById(instanceId, formBuilder);

  if (!element) {
    return <div>Divider element not found</div>;
  }

  const elementStyle = element.style || {};

  const getDividerStyles = () => {
    return {
      height: elementStyle.thickness || "1px",
      backgroundColor: elementStyle.color || "#dee2e6",
      margin: `${elementStyle.marginTop || "1rem"} 0 ${
        elementStyle.marginBottom || "1rem"
      } 0`,
      borderStyle: elementStyle.borderStyle || "solid",
      borderWidth:
        elementStyle.borderStyle === "none"
          ? "0"
          : elementStyle.thickness || "1px",
      borderColor: elementStyle.color || "#dee2e6",
      opacity: elementStyle.opacity || "1",
    };
  };

  const getLabelStyles = () => {
    return {
      fontSize: elementStyle.fontSize || "0.875rem",
      color: elementStyle.textColor || "#6c757d",
      backgroundColor: elementStyle.backgroundColor || "#ffffff",
      padding: elementStyle.labelPadding || "0 0.75rem",
      fontWeight: elementStyle.fontWeight || "500",
    };
  };

  if (elementStyle.showLabel && elementStyle.label?.label) {
    return (
      <div className="position-relative w-100">
        <hr style={getDividerStyles()} />
        <div
          className="position-absolute top-50 start-50 translate-middle"
          style={getLabelStyles()}
        >
          {elementStyle.label.label}
        </div>
      </div>
    );
  }

  return <hr style={getDividerStyles()} />;
};
